// src/lib/apiBase.js
//
// Single source of truth for the backend's base URL. Was hardcoded as
// 'http://localhost:8008' at 5 separate call sites (Chatbot.jsx,
// slmMentor.js, InfiniteCanvas.js, RequestAccess.jsx, billingApi.js) --
// none of it worked once deployed to a real domain. Set
// REACT_APP_API_BASE at build time (see .env.example) to point at the
// deployed backend; falls back to the local dev server otherwise.
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8008';
